import { Component } from '@angular/core';
import { TranslatePipe } from '@codeandweb/ngx-translate';

@Component({
  selector: 'app-partners',
  imports: [TranslatePipe],
  templateUrl: './partners.html',
  styleUrl: './partners.scss'
})
export class Partners {
  get getPartners(): string {
    return window.innerWidth > 768 ? '/images/partners/partners-big.webp' : '/images/partners/partners-small.webp';
  }
}
